import { observer } from "mobx-react-lite";
import { useEffect} from "react";
import { PubSubEvents } from "../../services/PubSubEvents";
import React from "react";
import { MainInfoTable } from "./MainInfoTable";
import { InspectionTable } from "./InspectionTable";
import { mainInfoStorage } from "../../services/ocr/MainInfoStorageModel";
import { inspectionInfoStorage } from "../../services/ocr/InspectionInfoStorageModel";
import { Grid } from "@mui/material";
import ReportLoader from "./ReportLoader";
import { DetectionList } from "./DetectionList";
import { InspectionInsightDetails } from "./InspectionInsightDetails";
import { OcrService } from "../../services/ocr/OcrService";


export interface IInspectionReport {
    fileId: number,
    onFinished(fileId: number): void,
    ocr: OcrService,
    children: any
}

export default observer(function InspectionReport(props: IInspectionReport) {
  const { fileId, onFinished, ocr } = props;

  useEffect(() => {
    if (fileId === undefined) return;
    var segmentationSubscribeToken = PubSub.subscribe(
      PubSubEvents.VideoOcrFinished,
      async (_event: string, notification: Notification) => {
        onFinished(notification.data.fileId);
      }
    );

    return function cleanup() {
      PubSub.unsubscribe(segmentationSubscribeToken);
    };
  }, [onFinished, fileId]);

  return (
    <Grid container spacing={2}>
      <ReportLoader ocr={ocr}>
        <Grid item xs={12} sm={7}>
            <Grid container direction="column" spacing={2} sx={{padding: 2}}>
                <Grid item xs={12} sx={{ width: "100%" }} id="pdf-content-table">
                  <MainInfoTable mainInfoStorage={mainInfoStorage} />
                </Grid>
                <Grid item xs={12} sx={{ width: "100%" }} id="pdf-content-table">
                  <InspectionTable inspectionInsightStorage={inspectionInfoStorage} ocrService={props.ocr} />
                </Grid>
              <Grid item xs={12} sx={{ width: "100%" }}>
                <DetectionList inspectionInsightStorage={inspectionInfoStorage} />
              </Grid>
            </Grid>
        </Grid>

        <Grid item xs={12} sm={5} data-html2canvas-ignore>
          <Grid container direction = "column" sx={{position: "sticky", top: "70px", width: "100%"}}>
          <Grid item sx={{ width: "100%"}}>
            {props.children}
          </Grid>
          <Grid item sx={{ width: "100%" }}>
           <InspectionInsightDetails inspectionInsightStorage={inspectionInfoStorage} />
          </Grid>
        </Grid>
        </Grid>
      </ReportLoader>
    </Grid>
  );
});

